<div class="modal-content">
  <form [formGroup]="ip800Form" id="ip800Form" name="ip800Form" class="form-horizontal" novalidate
    (ngSubmit)="ip800Form.valid && createIp800()">

    <div class="modal-header">
      <h4 class="modal-title">Formulario Ip800</h4>
      <button type="button" class="close" (click)="cancel()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="form-group row">
        <label class="col-md-3 col-form-label" for="name"><b>Nombre Completo</b></label>
        <div class="col-md-9">
          <input id="name" name="name" type="text" class="form-control" formControlName="name">
        </div>
      </div>
      <div class="row mb-2">
        <div class="form-group col-md-4">
          <label class="col-form-label" for="region"><b>Departamento</b><span appRequiredAsterisk
              [formGroup]="ip800Form" controlName="region"></span></label>
          <ng-select id="region" [items]="regions" bindLabel="name" [selectOnTab]="true" (change)="changeRegion($event)"
            formControlName="region">
          </ng-select>
        </div>
        <div class="form-group col-md-4">
          <label class="col-form-label" for="city"><b>Municipio</b><span appRequiredAsterisk [formGroup]="ip800Form"
              controlName="city"></span></label>
          <ng-select id="city" [items]="cities" bindLabel="name" [selectOnTab]="true" (change)="changeCity($event)"
            formControlName="city">
          </ng-select>
        </div>
        <div class="form-group col-md-4">
          <label class="col-form-label" for="colony"><b>Colonia</b><span appRequiredAsterisk [formGroup]="ip800Form"
              controlName="colony"></span></label>
          <ng-select id="colony" [items]="colonies" bindLabel="name" [selectOnTab]="true" formControlName="colony">
          </ng-select>
        </div>
      </div>

      <div class="form-group row">
        <label class="col-md-3 col-form-label" for="streetOrAvenue"><b>Calle o Avenida</b><span appRequiredAsterisk
            [formGroup]="ip800Form" controlName="streetOrAvenue"></span></label>
        <div class="col-md-9">
          <input id="streetOrAvenue" name="streetOrAvenue" type="text" class="form-control"
            formControlName="streetOrAvenue">
        </div>
      </div>
      <div class="form-group row">
        <label class="col-md-3 col-form-label" for="blockNumber"><b>Bloque</b><span appRequiredAsterisk
            [formGroup]="ip800Form" controlName="blockNumber"></span></label>
        <div class="col-md-9">
          <input id="blockNumber" name="blockNumber" type="text" class="form-control" formControlName="blockNumber">
        </div>
      </div>
      <div class="form-group row">
        <label class="col-md-3 col-form-label" for="houseNumber"><b>Número Casa</b><span appRequiredAsterisk
            [formGroup]="ip800Form" controlName="houseNumber"></span></label>
        <div class="col-md-9">
          <input id="houseNumber" name="houseNumber" type="text" class="form-control" formControlName="houseNumber"
            [class.is-invalid]="(ip800Form.get('houseNumber')?.touched || ip800Form.get('houseNumber')?.dirty) && ip800Form.get('houseNumber')?.invalid">
        </div>
      </div>
      <div class="row mb-2">
        <div class="form-group col-md-6">
          <label class="col-form-label" for="cellPhone"><b>Celular</b><span appRequiredAsterisk [formGroup]="ip800Form"
              controlName="cellPhone"></span></label>
          <input id="cellPhone" name="cellPhone" type="text" class="form-control" formControlName="cellPhone"
            [mask]="phoneMask" [showMaskTyped]="true"
            [class.is-invalid]="(ip800Form.get('cellPhone')?.touched || ip800Form.get('cellPhone')?.dirty) && ip800Form.get('cellPhone')?.invalid">
        </div>
        <div class="form-group col-md-6">
          <label class="col-form-label" for="otherPhone"><b>Teléfono de Casa</b><span appRequiredAsterisk
              [formGroup]="ip800Form" controlName="otherPhone"></span></label>
          <input id="otherPhone" name="otherPhone" type="text" class="form-control" formControlName="otherPhone"
            [mask]="phoneMask" [showMaskTyped]="true">
        </div>
      </div>
      <div class="form-group row">
        <label class="col-md-3 col-form-label" for="email"><b>Correo electrónico</b><span appRequiredAsterisk
            [formGroup]="ip800Form" controlName="email"></span></label>
        <div class="col-md-9">
          <input id="email" name="email" type="text" class="form-control" formControlName="email"
            [class.is-invalid]="(ip800Form.get('email')?.touched || ip800Form.get('email')?.dirty) && ip800Form.get('email')?.invalid">
        </div>
      </div>
      <div class="form-group row" *ngIf="isLegalEntity">
        <label class="col-md-3 col-form-label" for="seatFolioVolumeRegistration"><b>No. Asiento, folio y tomo /
            Matricula</b><span appRequiredAsterisk [formGroup]="ip800Form"
            controlName="seatFolioVolumeRegistration"></span></label>
        <div class="col-md-9">
          <input id="seatFolioVolumeRegistration" name="seatFolioVolumeRegistration" type="text" class="form-control"
            formControlName="seatFolioVolumeRegistration"
            [class.is-invalid]="(ip800Form.get('seatFolioVolumeRegistration')?.touched || ip800Form.get('seatFolioVolumeRegistration')?.dirty) && ip800Form.get('seatFolioVolumeRegistration')?.invalid">
        </div>
      </div>
      <div class="form-group row" *ngIf="isLegalEntity">
        <label class="col-md-3 col-form-label" for="commercialRegistry"><b>Registro Mercantil</b><span
            appRequiredAsterisk [formGroup]="ip800Form" controlName="commercialRegistry"></span></label>
        <div class="col-md-9">
          <input id="commercialRegistry" name="commercialRegistry" type="text" class="form-control"
            formControlName="commercialRegistry"
            [class.is-invalid]="(ip800Form.get('commercialRegistry')?.touched || ip800Form.get('commercialRegistry')?.dirty) && ip800Form.get('commercialRegistry')?.invalid">
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-secondary" (click)="cancel()">Cancelar</button>
      <button type="submit" class="btn btn-outline-success">Confirmar</button>
    </div>

  </form>
</div><!-- /.modal-content -->